import { z } from 'zod';
import { quantitySchema } from '../validation';
import { countrySchema } from './country.schema';

const country = countrySchema.Enum;
export const vehicleCountrySchema = z.enum([
  country.saudi_arabia,
  country.united_arab_emirates,
  country.jordan,
  country.egypt,
  country.syria,
  country.kuwait,
  country.other,
]);

export type VehicleCountry = z.infer<typeof vehicleCountrySchema>;

//* group
export const vehicleGroupSchema = z.enum([
  'truck', // تريلا
  'lorry',
  'dyna',
  'van',
  'pickup', // RAM / hilux toyata / etc
  'sedan', // normal 4 seat car
  'motorcycle',
]);
export type VehicleGroup = z.infer<typeof vehicleGroupSchema>;
/** truck vehicle types */
export const vehicleTruckTypesSchema = z.enum([
  'truck_flatbed_container', // this exactly the same as flatbed ... te only difference is that when we order, the user should specify if he wants to ship a container or normal items
  'truck_flatbed', //تريلا سطحة
  'truck_curtain_side', //تريلا ستارة
  'truck_chilled', // تريلا مبرد
  'truck_closed', // تريلا مغلقة
]);
/** dyna vehicle types */
export const vehicleDynaTypesSchema = z.enum([
  'dyna_closed', //دينا صندوق
  'dyna_chilled', //دينا مبرد
  'dyna_dump', //دينا قلاب
  'dyna_crane', //دينا ونش
  'dyna_open_top', //دينا شبك
]);
/** lorry vehicle types */
export const vehicleLorryTypesSchema = z.enum([
  'lorry_closed', // لوري مقفل
  'lorry_sides', // لوري جوانب
  'lorry_open_top', // لوري شبك
  'lorry_chilled', //لوري مبرد
  'lorry_crane', // لوري ونش
]);
/** van vehicle types */
export const vehicleVanTypesSchema = z.enum(['van_chilled', 'van_closed']);

/** all vehicle types */
export const vehicleTypesSchema = z.enum([
  ...vehicleTruckTypesSchema.options,
  ...vehicleDynaTypesSchema.options,
  ...vehicleLorryTypesSchema.options,
  ...vehicleVanTypesSchema.options,
  'other',
]);
/** all vehicle Types */
export type VehicleTypes = z.infer<typeof vehicleTypesSchema>;
/** the supported Vehicle types */

//* brand
export const vehicleBrandSchema = z.enum([
  'isuzu',
  'volvo',
  'mercedes',
  'howo',
  'toyota',
  'mitsubishi',
  'hino',
  'scania',
  'sinotruck',
  'other',
]);
export type VehicleBrand = z.infer<typeof vehicleBrandSchema>;

//* trailer type
export const vehicleTrailerTypeSchema = z.enum([
  // seats for sedan people
  'closed_box',
  'chill_box',
  'dump',
  'side_curtain',
  'side_down',
  'open_top',
  'crane',
  'flatbed',
  'pickup_truck',
]);
export type VehicleTrailerType = z.infer<typeof vehicleTrailerTypeSchema>;

/** type of vehicle & quantity */
export const vehicleQuantityAndTypeSchema = z.object({
  /** vehicle type */
  type: vehicleTypesSchema,
  /** the count of vehicle types */
  count: quantitySchema.min(1),
});
export type VehicleQuantityAndType = z.infer<typeof vehicleQuantityAndTypeSchema>;
